<template>
	<div style="background: #f2f2f2;" v-show="show">
		<common-head active="0" state="1"></common-head>
		
		<!-- 首页广告 -->
		<index-banner></index-banner>

		<!-- 活动内容 -->
		<div class="act">
			<div class="act-image">
				<img :src="info.act_image" alt="">
			</div>

			<div class="act-info">
				<div class="act-name">{{info.act_name}}</div>
				<div class="act-time">时间：{{info.act_start_time}} —— {{info.act_end_time}}</div>
				<div class="act-address">地址：{{info.act_address}}</div>
				<div class="act-address">费用：￥{{info.act_price}}</div>
				<div class="act-address">浏览：{{info.act_view}}人看过</div>
			</div>
		

			<div class="act-content" v-html="info.act_content"></div>
		</div>

		<common-footer></common-footer>
	</div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
    import { share } from "@/static/js/share.js";
	import commonHead from '@/components/wap/commonHead.vue';
	import commonFooter from '@/components/wap/commonFooter.vue';
	import indexBanner from '@/components/wap/indexBanner.vue';
	import { activity_detail } from '@/api/activity.js';

	export default {
		name: 'detail',
		components: {
			commonHead, commonFooter,indexBanner
		},
		data() {
			return {
				show:false,
				info:{
					act_name:'资讯',
				},
			}
		},
		metaInfo() {
			site_name().then(res => {
                document.title = this.info.act_name + '-' + res.site_name;
                return {
                    title: this.info.act_name + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' }
                    ],
                }
            });
		},
		created() {
			const id = this.$route.query.id;
			this.get_data(id);
		},
		methods: {
			get_data(id) {
				activity_detail({id:id}).then(res=>{
					if(res.code==1){
						this.info = res.data;
						this.show = true;
                        share(window.location.pathname + window.location.search, res.data.act_name);
					}
				});
			},
		},
	}
</script>
<style scoped>
	.act{
		width: calc(100% - 30px);
		margin: 15px;
		position: relative;
		background: #fff;
	}
	.act-info{
		width: calc(100% - 30px);
		padding: 15px;
	}
	.act-image{
		width: 100%;
	}
	.act-image img{
		width: 100%;
	}
	.act-name{
		font-size: 18px;
		font-weight: 700;
		margin-bottom: 15px;
	}
	.act-time,.act-address{
		color: #666;
		font-size: 12px;
		margin-bottom: 5px;
	}
	.act-content{
		background: #fff;
		width: calc(100% - 30px);
		padding: 15px;
		padding-top: 20px;
		z-index: 9999;
	}
	/deep/ .act-content img{
		max-width: 100%;
	}
</style>